
import { computed, defineComponent, onBeforeMount, onMounted, reactive, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { $t as lang } from '@/Tool'
import vuex from '@/store'
interface IImgList {
  key: string
  nextKey: string
  url: string
  next: string
}
export default defineComponent({
  components: {},
  props: {
    isActive: {
      //判断是否是由组件打开  true  为组件
      type: Boolean,
      default: () => false,
    },
    parentImgList: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    onMounted(() => {
      if (props.parentImgList.length > 0) {
        const { url } = props.parentImgList[0] as IImgList
        data.currentStepImg.url = url || ''
        data.MountedImgList = props.parentImgList as []
      } else {
        data.MountedImgList = data.imgList as []
      }
    })
    const router = useRouter()
    let data = reactive({
      currentStepImg: {
        key: 'template1',
        url: require('./images/20221220/pic1.png'),
      }, // 当前展示的图片
      imgList: [
        {
          key: 'template1',
          nextKey: 'template2',
          url: require('./images/20221220/pic1.png'),
          next: require('./images/20221220/pic2.png'),
        },
        {
          key: 'template2',
          nextKey: 'template3',
          url: require('./images/20221220/pic2.png'),
          next: require('./images/20221220/pic3.png'),
        },
        {
          key: 'template3',
          nextKey: 'template4',
          url: require('./images/20221220/pic3.png'),
          next: require('./images/20221220/pic4.png'),
        },
        {
          key: 'template4',
          nextKey: 'template5',
          url: require('./images/20221220/pic4.png'),
          next: require('./images/20221220/pic5.png'),
        },
        {
          key: 'template5',
          nextKey: 'template6',
          url: require('./images/20221220/pic5.png'),
          next: require('./images/20221220/pic6.png'),
        },
        // {
        //   key: 'library',
        //   nextKey: 'composite',
        //   url: require('./images/guide-library.gif'),
        //   next: require('./images/guide-composite.png'),
        // },
        // {
        //   key: 'composite',
        //   nextKey: 'videos',
        //   url: require('./images/guide-composite.png'),
        //   next: require('./images/guide-videos.png'),
        // }, // 视频合成
        // {
        //   key: 'videos',
        //   nextKey: 'videoDetail',
        //   url: require('./images/guide-videos.png'),
        //   next: require('./images/guide-videoDetail.png'),
        // }, // 视频作品
        {
          key: 'template6',
          nextKey: 'back',
          url: require('./images/20221220/pic6.png'),
          next: false,
        }, // 视频详情
        // {
        //   key: 'back',
        //   nextKey: 'template',
        //   url: require('./images/guide-back.png'),
        //   next: false,
        // }, // 回到操作引导
      ],
      MountedImgList: [],
    })

    // 切换图片
    function switchImg() {
      const item: any = data.MountedImgList.find((i: any) => i.key === data.currentStepImg.key)

      if (item?.next) {
        data.currentStepImg.url = item?.next
        data.currentStepImg.key = item?.nextKey || 'template1'
      } else {
        if (props.isActive) {
          props.parentImgList.length < 1 && emit('onHandleMenu')
          emit('onHandleClose')
          return
        }
        const userInfo = JSON.parse(sessionStorage.getItem('__user') + '')
        if (userInfo.user?.info?.corpType == 1) {
          // if(userInfo.user?.info?.type == 1){
          router.push('/vshow/newHomePage')
        } else {
          skipDigitalMarket()
          // router.push('/vshow/workBench/newBench')
        }
        return
      }
    }
    function skipDigitalMarket() {
      const menus = computed(() => vuex.state.menus)
      vuex.state.tabsArr.push({
        key: 'digitalMarket',
        name: `${lang('mainMenu.firstMenu.digitalMarket')}&digitalMarket`,
        url: '/vshow/digitalMarket',
        parentKey: '',
        child: [],
      })
      const newTabsArr = vuex.state.tabsArr
      nextTick(() => {
        vuex.commit('set_data', {
          tabsArr: newTabsArr,
          activeTabName: `${lang('mainMenu.firstMenu.digitalMarket')}&digitalMarket`,
        })
        // 设置选中一级菜单
        menus.value.forEach((item: any) => {
          item.isSelect = item.key === 'home'
        })
        vuex.commit('set_data', {
          selectMenu: {
            child: [],
            icon: 'iconfont icon-moteshichang',
            isSelect: true,
            key: 'digitalMarket',
            label: '数字市场',
            parentKey: '',
            title: '数字市场',
            url: '/vshow/digitalMarket',
            visible: true,
          },
        })
        router.push('/vshow/digitalMarket')
      })
    }

    function exitGuide() {
      if (props.isActive) {
        props.parentImgList.length < 1 && emit('onHandleMenu')
        emit('onHandleClose')
        return
      }

      const userInfo: any = JSON.parse(sessionStorage.getItem('__user') + '')
      const menus = computed(() => vuex.state.menus)
      const menuCodes = userInfo?.user.info?.menuCodes || []
      const hasHomePage = computed(() => menuCodes.indexOf('home') >= 0)
      if (userInfo.user?.info?.corpType == 1 && hasHomePage.value) {
        // 设置选中一级菜单
        menus.value.forEach((item: any) => {
          item.isSelect = item.key === 'home'
        })
        vuex.commit('set_data', {
          selectMenu: {
            child: [],
            icon: 'iconfont icon-moteshichang',
            isSelect: true,
            key: 'home',
            label: '首页',
            parentKey: '',
            title: '首页',
            url: '/vshow/newHomePage',
            visible: true,
          },
        })
        router.push('/vshow/newHomePage')
      } else {
        skipDigitalMarket()
      }
    }
    return {
      data,
      switchImg,
      exitGuide,
      lang,
    }
  },
})
